import React, { useEffect } from 'react';
import { useState } from 'react';
import DataTable from '../../components/datatable';
import { PAGINATION_DEFAULT, salaryAdvanceStatusConfig } from '../../utils/constants';
import { useSelector } from 'react-redux';
import { useGetCabinetSalaryAdvances } from '../../redux/employee-folder/hook';

const SalaryAdvanceFolder = ({employeeId}) => {

  const { user } = useSelector((state) => state.userSlice);

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
  });

  const { data: salary_advances } = useGetCabinetSalaryAdvances(
    employeeId,
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter,
    pagination?.search,
  );


  const tableConfig = {
    headers: [
      'Employee Name',
      'Phone number',
      'Purpose',
      'Month',
      'Amount',
      'Status',
    ],
    keys: ['employeeName', 'phone', 'purpose', 'formatted_month', 'amount', 'status'],
    mobileHeader: {
      left: {
        title: 'Employee Name',
        key: 'employeeName',
      },
      right: {
        title: 'Amount',
        key: 'amount',
      },
    },
  };

  return (
    <div className='flex flex-col'>
        <div className='mt-9'>
            <div className='flex md:flex-row gap-4 flex-wrap-reverse'>
                <div className='w-[100%]'>
                    <DataTable
                    data={salary_advances}
                    tableConfig={tableConfig}
                    statusConfig={salaryAdvanceStatusConfig}
                    // actionConfig={actionConfig}
                    noCheck={true}
                    // computedActions={true}
                    updatePagination={(data) => setPagination(data)}
                    />
                </div>
            </div>
        </div>
    </div>
  );
};

export default SalaryAdvanceFolder;
